/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/models/DataResponseModel.js"/>
/// <reference path="~/js/lib/velir/velir.library.js"/>

(function(_) {
  var ns, sharedNs;

  ns = window.nspace("ccc.viz.map.models");
  sharedNs = window.nspace("ccc.viz.shared.models");

  /**
   * Data response model is responsible for querying the server-side for data,
   * storing the response, and other views listen for the response to change
   * in order to be updated when new data is retrieved
   */
  ns.DataResponseModel = sharedNs.DataResponseModel.extend({
    getDataResponseOnChange: function() {
      // Don't bother requesting new data if the only change was to the selectedFips.
      if (
        _.size(this.selectorsModel.changed) === 1 &&
        this.selectorsModel.changed.hasOwnProperty("selectedFips")
      ) {
        return;
      }

      this.getDataResponse();
    },

    getFilterString: function() {
      var params, filterStringNvc, filterString;

      params = window.ccc.viz.util.UrlParams;

      filterStringNvc = new window.velir.collections.NameValueCollection();
      filterStringNvc.add(
        params.indicator,
        this.selectorsModel.get("indicatorId")
      );
      filterStringNvc.add(
        params.timeFrame,
        this.selectorsModel.get("timeFrameId")
      );
      filterStringNvc.add(
        params.locationType,
        this.selectorsModel.get("locationTypeId")
      );
      filterStringNvc.add(
        params.dataFormat,
        this.selectorsModel.get("dataFormatId")
      );
      filterStringNvc.add(
        params.characteristic,
        this.selectorsModel.get("characteristicId")
      );

      filterString = filterStringNvc.toQueryString();

      return filterString;
    },

    getDataParams: function(filterString) {
      return {
        filterString: filterString,
        numBreaks: window.ccc.viz.map.config.MapConfig.getNumBreaks()
      };
    },

    hasData: function() {
      return this.get("response").hasData;
    }
  });
})(_);
